const STORAGE_KEY = 'attribution_params'

const TRACKED_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'yclid',
  'gclid',
  'ymclid',
  'from',
]

function safeStorage() {
  if (typeof window === 'undefined') return null
  return window.localStorage
}

function readStored() {
  const storage = safeStorage()
  if (!storage) return {}
  try {
    return JSON.parse(storage.getItem(STORAGE_KEY) || '{}')
  } catch {
    return {}
  }
}

function writeStored(data) {
  const storage = safeStorage()
  if (!storage) return
  storage.setItem(STORAGE_KEY, JSON.stringify(data))
}

/** Захват utm_* / yclid из URL при первом визите; не перезаписывает уже сохранённые ключи. */
export function captureAttributionFromUrl(href) {
  if (typeof window === 'undefined') return readStored()

  const url = new URL(href || window.location.href)
  const incoming = {}
  for (const key of TRACKED_PARAMS) {
    const value = url.searchParams.get(key)
    if (value) incoming[key] = value
  }

  if (!Object.keys(incoming).length) return readStored()

  const stored = readStored()
  const merged = { ...stored }
  for (const key of Object.keys(incoming)) {
    if (!stored[key]) merged[key] = incoming[key]
  }
  if (!stored.captured_at) {
    merged.captured_at = new Date().toISOString()
  }
  writeStored(merged)
  return merged
}

export function initAttribution() {
  captureAttributionFromUrl()
}

export function getStoredAttribution() {
  return readStored()
}

/** Поля для CRM и register. */
export function getAttributionForPayload() {
  const stored = readStored()
  const referrer = typeof document !== 'undefined' ? document.referrer : ''
  const landingPage =
    typeof window !== 'undefined'
      ? `${window.location.pathname}${window.location.search}`
      : ''
  return {
    utm_source: stored.utm_source || '',
    utm_medium: stored.utm_medium || '',
    utm_campaign: stored.utm_campaign || '',
    utm_content: stored.utm_content || '',
    utm_term: stored.utm_term || '',
    yclid: stored.yclid || '',
    gclid: stored.gclid || '',
    ymclid: stored.ymclid || '',
    traffic_source: stored.utm_source || stored.from || referrer || 'direct',
    landing_page: landingPage,
  }
}
